/**
 * File: ForgotPasswordPage.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v2.1.1
 * Created: 2025-07-23
 * Last Updated: 2026-06-22
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Third-party packages
import { useNavigate } from "react-router-dom";

// Local project files
import { TextButton } from "../components/ui/Buttons";
import { routes } from "../constants/routes";
import { sendOtpCode } from "../utils/ServiceRequests";
import AuthPrompt from "../components/forms/AuthPrompt";
import EmailField from "../components/forms/EmailField";
import FormHeader from "../components/forms/FormHeader";
import Logo from "../components/ui/Logo";

/**
 * [TODO: Component description here]
 *
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function ForgotPasswordPage({ schema, otpEmail, setOtpEmail }) {
    const redirect = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            await sendOtpCode(otpEmail);
            redirect(routes.public.auth.verify.abs);
        } catch (error) {
            alert(error.message);
        }
    };

    return (
        <>
            <article className="auth__article">
                <form className="auth__form" onSubmit={handleSubmit}>
                    <Logo isLink={true} />
                    <FormHeader {...schema.formHeader} />
                    <fieldset>
                        <EmailField email={otpEmail} setEmail={setOtpEmail} />
                    </fieldset>
                    <TextButton {...schema.textButton}></TextButton>
                    <hr></hr>
                    <AuthPrompt {...schema.authPrompt} />
                </form>
            </article>
        </>
    );
}

export default ForgotPasswordPage;
